import viewpaths from "global/constants/ViewPathConstants";
import { Redirect } from "react-router-dom";

/**
 * /admin redirects to the Analytics page as the default admin landing.
 */
const AdminDashboard = () => {
  return <Redirect to={viewpaths.adminBlogsViewPath} />;
};

export default AdminDashboard;
